//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
};